import { paths } from '@primum/api-types';
import type { MessageData } from '@/types/messageData';
import { fetchClient } from '@/util/fetchClient';

export type SendMessageBodyV2 =
  paths['/v2/inquiries/{conversationId}/messages']['post']['requestBody']['content']['application/json'];

type SendMessageParamsV2 =
  paths['/v2/inquiries/{conversationId}/messages']['post']['parameters']['path'];

/**
 * Extended message params that include the new data field.
 * - `files` is kept for backwards compatibility with existing file attachments
 * - `data` is the new unified field for all other message metadata
 */
type SendMessageParams = SendMessageBodyV2 &
  SendMessageParamsV2 & {
    data?: MessageData;
  };

export async function sendNewMessageV2({
  conversationId,
  message,
  files,
  data,
  replyDraftId,
  clientMessageId,
}: SendMessageParams) {
  try {
    const { data: responseData } = await fetchClient.POST(
      '/v2/inquiries/{conversationId}/messages',
      {
        params: {
          path: {
            conversationId,
          },
        },
        body: {
          message,
          files,
          // Pass data to the API - the backend will store it in Twilio message attributes
          ...(data && { data }),
          ...(replyDraftId && { replyDraftId }),
          ...(clientMessageId && { clientMessageId }),
        } as SendMessageBodyV2,
      }
    );

    return responseData;
  } catch (error) {
    throw error;
  }
}
